import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "locationCheckbox",
    "storageUnitTypeCheckbox",
    "storageUnitsEmpty",
    "storageUnitsPresent",
  ]

  connect() {
    this.filterStorageUnitTypes()
  }

  filterStorageUnitTypes() {
    const selectedLocationIds = new Set(
      this.locationCheckboxTargets
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value)
    )

    let listEmpty = true

    this.storageUnitTypeCheckboxTargets.forEach((checkbox) => {
      const sutLocationIds = new Set(checkbox.dataset.locationIds.split(",").map((id) => id.trim()))

      if (selectedLocationIds.intersection(sutLocationIds).size > 0) {
        listEmpty = false
        checkbox.closest("[data-storage-unit-type]").classList.remove("hidden")
        checkbox.disabled = false
        checkbox.dispatchEvent(new Event("change"))
      } else {
        checkbox.closest("[data-storage-unit-type]").classList.add("hidden")
        checkbox.checked = false
        checkbox.disabled = true
        checkbox.dispatchEvent(new Event("change"))
      }
    })

    if (listEmpty) {
      this.storageUnitsEmptyTargets.forEach((target) => {
        target.classList.remove("hidden")
      })

      this.storageUnitsPresentTargets.forEach((target) => {
        target.classList.add("hidden")
      })
    } else {
      this.storageUnitsEmptyTargets.forEach((target) => {
        target.classList.add("hidden")
      })

      this.storageUnitsPresentTargets.forEach((target) => {
        target.classList.remove("hidden")
      })
    }
  }
}
